<template>
    <div v-if="show" :class="className" class="alert alert-dismissible fade show text-center">
        <b v-if="label" class="alert-heading">
            {{ label }}
        </b>

        <slot />

        <button v-if="closable" @click.prevent="close" type="button" class="close focus:outline-none">
            <span>
                <i class="fad fa-times-square"></i>
                <!-- &times; -->
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: [
        'type',
        'title',
        'show',
        'closable'
    ],

    data: () => ({}),

    created() {
        //
    },

    mounted() {},

    computed: {
        className() {
            return 'alert-' + this.type;
        },

        label() {
            if (this.title) {
                return this.title;
            } else if (this.type === 'success') {
                return 'Success!';
            } else if (this.type === 'error') {
                return 'Problem!';
            }
        }
    },

    methods: {
        close() {
            this.show = false;
        }
    }
}
</script>

<style lang="scss" scoped>
// @todo move alert css into here
</style>
